import styled from 'styled-components';

import { ThemeType } from '../../themeStyled';

export const TextWrapper = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'hoverColor' && prop !== 'fontSize',
})<{
	selected?: boolean;
	fontSize?: number;
	hoverColor?: string;
}>`
	border: 1px solid ${({ theme }: { theme: ThemeType }) => theme.colors.erik.veryLightGray};
	border-radius: 12px;
	padding: 12px;
	width: fit-content;
	height: 48px;

	background-color: ${({ selected, theme }) => (selected ? theme.colors.erik.blue : 'white')};
	box-shadow: ${({ theme }: { theme: ThemeType }) => theme.boxShadow.default};

	display: flex;
	align-items: center;
	justify-content: center; /* vycentruj ikonu */

	flex-shrink: 0; /* bráni roztiahnutiu, ak je vo flex kontejnery */

	&:hover {
		cursor: pointer;
		box-shadow: ${({ theme }: { theme: ThemeType }) => theme.boxShadow.hover};
		border: 1px solid ${({ hoverColor, theme }) => (hoverColor ? hoverColor : theme.colors.erik.veryLightGray)};
	}

	h6,
	h5 {
		${({ fontSize }) =>
			fontSize &&
			`
      font-size: ${fontSize}rem;
    `}
	}
`;

export const DisabledDiv = styled.div<{ disabled?: boolean }>`
	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
	filter: ${({ disabled }) => (disabled ? 'grayscale(40%)' : 'none')};
`;
